import { ListItemButton, List, Modal, IconButton, Tooltip } from '@mui/material';
import axios from 'axios';
import { TextField, Button, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useEffect, useState } from 'react';
import { API_BASE_URL } from '../../configuration/Configuration';
import Department from '../department/Department';
import { useAuth } from '../../context/AuthContext';
import { Delete } from '@mui/icons-material';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'white',
  boxShadow: 24,
  p: 3,
  borderRadius: 1,

  display: 'flex',
  flexDirection: 'column',
  gap: 3,
};

const Departments = () => {
  const { userType, user } = useAuth();
  const [departments, setDepartments] = useState();
  const [isCreating, setIsCreating] = useState(false);
  const [name, setName] = useState('');
  const [nameError, setNameError] = useState('');

  const [selectedDepartment, setSelectedDepartment] = useState();
  
  // Helper function to validate department name
  const validateDepartmentName = (inputName) => {
    if (!inputName.trim()) {
      setNameError('Department name is required');
      return false;
    }
    
    const existingDepartment = departments?.find(
      dept => dept.name.toLowerCase() === inputName.toLowerCase()
    );
    
    if (existingDepartment) {
      setNameError(`A department with the name "${inputName}" already exists`);
      return false;
    }
    
    setNameError('');
    return true;
  };
  
  const handleNameChange = (e) => {
    const newName = e.target.value;
    setName(newName);
    
    // Validate in real-time if departments are loaded
    if (departments) {
      validateDepartmentName(newName);
    }
  };
  useEffect(() => {
    if (user) {
      axios
        .get(`${API_BASE_URL}/api/departments/${user}`)
        .then((res) => {
          setDepartments(res.data);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }, [user]);

  const handleCreate = () => {
    setIsCreating(!isCreating);
  };
  const createDepartment = (e) => {
    e.preventDefault();
    
    const trimmedName = name.trim();

    if (trimmedName && user) {
      // Validate the name
      if (!validateDepartmentName(trimmedName)) {
        return;
      }

      axios
        .post(`${API_BASE_URL}/api/departments/${user}`, { name: trimmedName })
        .then((res) => {
          setName('');
          setNameError('');
          setIsCreating(false);
          setDepartments(res.data);
        })
        .catch((err) => {
          console.log(err);
          if (err.response?.status === 400 && err.response?.data?.error) {
            setNameError(err.response.data.error);
          } else {
            setNameError('Error creating department. Please try again.');
          }
        });
    } else if (!user) {
      console.error('Cannot create department: User is not defined');
    } else {
      setNameError('Department name is required');
    }
  };

  const hanldeDepartmentSelect = (id, name) => {
    setIsCreating(false);
    setSelectedDepartment({ id: id, name: name });
  };

  const handleDeleteDepartment = (departmentId, departmentName) => {
    // First confirmation
    if (window.confirm(`Are you sure you want to delete the department "${departmentName}"?`)) {
      // Second confirmation
      if (window.confirm(`This action will soft delete the department "${departmentName}". This action can be undone by a database administrator. Continue?`)) {
        axios
          .post(`${API_BASE_URL}/api/department/delete/${departmentId}/`, {
            username: user
          })
          .then((res) => {
            setDepartments(res.data);
            // If the deleted department was selected, clear the selection
            if (selectedDepartment?.id === departmentId) {
              setSelectedDepartment(null);
            }
          })
          .catch((err) => {
            console.log(err);
            if (err.response?.status === 403) {
              alert('Only tender managers can delete departments.');
            } else if (err.response?.status === 404) {
              alert('Department not found or already deleted.');
            } else {
              alert('Error deleting department. Please try again.');
            }
          });
      }
    }
  };

  return (
    <>
      {user ? (
        <div>
          <Typography variant="h6" align="left">
            Departments
          </Typography>
          <div className="departmentWrapper">
            <div className="departmentList">
              <div className="listWrap">
                <List>
                  {userType && userType.isAdmin && (
                    <ListItemButton
                      //selected={selectedIndex === 2}
                      onClick={(event) => handleCreate(event)}
                    >
                      + Create Department
                    </ListItemButton>
                  )}
                  {departments &&
                    departments.map((el) => {
                      return (
                        <ListItemButton
                          selected={selectedDepartment?.id === el?.id}
                          onClick={() => hanldeDepartmentSelect(el.id, el.name)}
                          key={el.id}
                          sx={{ 
                            display: 'flex', 
                            justifyContent: 'space-between',
                            alignItems: 'center'
                          }}
                        >
                          <span>{el.name}</span>
                          {userType && userType.isAdmin && (
                            <Tooltip title="Delete Department" placement="top">
                              <IconButton
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation(); // Prevent department selection when clicking delete
                                  handleDeleteDepartment(el.id, el.name);
                                }}
                                sx={{ color: 'error.main' }}
                              >
                                <Delete fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          )}
                        </ListItemButton>
                      );
                    })}
                </List>
              </div>
            </div>
            <div className="departmentView">
              {isCreating ? (
                <Modal
                  open={isCreating}
                  onClose={() => {
                    setIsCreating(false);
                    setName('');
                    setNameError('');
                  }}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={modalStyle}>
                    <Typography
                      id="modal-modal-title"
                      variant="h6"
                      component="h2"
                      sx={{ mb: -1 }}
                    >
                      Add new department
                    </Typography>

                    <TextField
                      required
                      id="name"
                      size="small"
                      value={name}
                      onChange={handleNameChange}
                      label="Department Name"
                      error={!!nameError}
                      helperText={nameError}
                    />
                    <Button
                      type="submit"
                      onClick={createDepartment}
                      variant="contained"
                      disabled={!!nameError || !name.trim()}
                    >
                      Create
                    </Button>
                  </Box>
                </Modal>
              ) : (
                <>
                  {departments?.length > 0 ? (
                    <>
                      {selectedDepartment ? (
                        <Department
                          userType={userType}
                          dep={selectedDepartment}
                        />
                      ) : (
                        <div>Select Department</div>
                      )}
                    </>
                  ) : (
                    <div>No departments created</div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div>Loading user information...</div>
      )}
    </>
  );
};

export default Departments;
